import {
    FC,
    ReactElement,
    useEffect,
} from 'react'
import { Route, Routes } from 'react-router'

import { LoadingSpinner } from './components'
import { ConnectedCacheBuster } from './connectors/ConnectedCacheBuster/ConnectedCacheBuster'
import { InactiveUserRouteGroup } from './containers'
import { PrivateRouteGroup } from './containers/PrivateRouteGroup/PrivateRouteGroup'
import { trans } from './helpers/trans'
import { RegistrationPage } from './pages'
import { ChangePasswordPincodePage } from './pages/ChangePasswordPincodePage/ChangePasswordPincodePage'
import { ErrorPage } from './pages/ErrorPage/ErrorPage'
import { FeedbackPage } from './pages/FeedbackPage/FeedbackPage'
import { LoginPage } from './pages/LoginPage/LoginPage'
import { useTypedDispatch, useTypedSelector } from './redux/store'
import { getProfileOfCurrentUser } from './redux/user/userActions'
import { UserStatus } from './types/userStatus'

export const App: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()
    const { apiToken } = useTypedSelector(state => state.authenticationReducer)
    const { error: appError } = useTypedSelector(state => state.appReducer)
    const { currentUser } = useTypedSelector(state => state.userReducer)
    const isAuthenticated = !! apiToken

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(getProfileOfCurrentUser())
        }
    }, [])

    const renderApp = (): ReactElement => {
        if (apiToken && ! currentUser) {
            return <LoadingSpinner />
        }

        if (currentUser?.status === UserStatus.inActive) {
            return <InactiveUserRouteGroup />
        }

        if (appError) {
            return <ErrorPage errorCode={appError.code} fullHeight />
        }

        return (
            <Routes>
                <Route path={`/${trans('nav.login.link')}`} element={<LoginPage />} />
                <Route path={`/${trans('nav.feedback.link')}/:feedbackUuid`} element={<FeedbackPage />} />
                <Route path={`/${trans('nav.completeRegistration.link')}`} element={<RegistrationPage />} />
                <Route path={`/${trans('nav.forgotPassword.link')}`} element={<ChangePasswordPincodePage />} />
                <Route path="/*" element={<PrivateRouteGroup isAuthenticated={isAuthenticated} />} />
            </Routes>
        )
    }

    return (
        <ConnectedCacheBuster>
            {renderApp()}
        </ConnectedCacheBuster>
    )
}
